<script>
import BaseLidar from '../BaseLidar'

export default {
  name: 'DataDisplayO3Lidar',
  routeInfo: {
    label: '臭氧雷达',
    icon: 'fa fa-users'
  },
  extends: BaseLidar,
  computed: {
    siteDeviceCategory: () => process.env.O3_LIDAR_DEVICE_CATEGORY
  }
}
</script>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/02O3Lidar/index.vue